import type {
  ICompanyHoliday,
  ICompanyHolidayBody,
} from '../../services/companyHolidayService';
import { dateOnlyToPickerDate } from '../../utils/dateOnly';
import { toDateOnly } from './pricingSettings';

const text = (value: unknown) =>
  typeof value === 'string' ? value.trim() : '';

const checked = (value: unknown) => value === true || value === 'true';

export const toHolidayFormValues = (holiday: ICompanyHoliday) => ({
  ...holiday,
  holidayDate: dateOnlyToPickerDate(holiday.holidayDate)?.toISOString(),
});

export type CompanyHolidayBodyResult =
  | { ok: true; body: ICompanyHolidayBody }
  | { ok: false; error: string };

export const companyHolidayBody = (
  item: Record<string, unknown>
): CompanyHolidayBodyResult => {
  const name = text(item.name);
  const region = text(item.region);
  const holidayDate = text(item.holidayDate);
  if (!name || !region || !holidayDate) {
    return { ok: false, error: 'Name, date, and region are required.' };
  }
  return {
    ok: true,
    body: {
      holidayDate: toDateOnly(holidayDate),
      name,
      region,
      isActive: checked(item.isActive),
    },
  };
};
